'use strict';

var PROPOSAL_VENUE_INITIATED = 'PROPOSAL_VENUE_INITIATED';
var PROPOSAL_INQUIRY = 'PROPOSAL_INQUIRY';
var PROPOSAL_CLIENT_REQUESTED = 'PROPOSAL_CLIENT_REQUESTED';

var ER_INQUIRY = 'ER_INQUIRY';
var ER_VENUE_VIEW_VENUE = 'ER_VENUE_VIEW_VENUE';
var ER_VENUE_VIEW_SPACE = 'ER_VENUE_VIEW_SPACE';
var ER_BUILD_MY_PROPOSAL = 'ER_BUILD_MY_PROPOSAL';
var ER_CONCIERGE_VENUE_SEARCH = 'ER_CONCIERGE_VENUE_SEARCH';

var ADMIN_CAWP = 'ADMIN_CAWP';
var ADMIN_SILENT_CAWP = 'ADMIN_SILENT_CAWP';
var ADMIN_INVISIBLE_BOOKING = 'ADMIN_INVISIBLE_BOOKING';

module.exports = {
  PROPOSAL_VENUE_INITIATED: PROPOSAL_VENUE_INITIATED,
  PROPOSAL_INQUIRY: PROPOSAL_INQUIRY,
  PROPOSAL_CLIENT_REQUESTED: PROPOSAL_CLIENT_REQUESTED,
  ER_INQUIRY: ER_INQUIRY,
  ER_VENUE_VIEW_VENUE: ER_VENUE_VIEW_VENUE,
  ER_VENUE_VIEW_SPACE: ER_VENUE_VIEW_SPACE,
  ER_BUILD_MY_PROPOSAL: ER_BUILD_MY_PROPOSAL,
  ER_CONCIERGE_VENUE_SEARCH: ER_CONCIERGE_VENUE_SEARCH,
  ADMIN_CAWP: ADMIN_CAWP,
  ADMIN_SILENT_CAWP: ADMIN_SILENT_CAWP,
  ADMIN_INVISIBLE_BOOKING: ADMIN_INVISIBLE_BOOKING
};